import { get, post } from "../axios/http"
import qs from 'qs'


export const getTaskCount = () => get(`/api/automations/task/count`)

export const getToDoList = () => get('/api/automations/task/todoList?type=1')

export const getFaqiList = () => get('/api/automations/task/todoList?type=0')

export const getCompletedList = () => get('/api/automations/task/todoList?type=2')

export const getProcessDetail = (id) => get(`/api/automations/task/detail?id=${id}`)

export const getWorksheetInfo = (id) => get(`/api/app/worksheet/info/get?id=${id}`)

export const getProcessHistory = (params) => get(`/api/automations/instance/history?${qs.stringify(params)}`)

export const updateProcess = (params) => post('/api/automations/task/update', params)

export const updateRow = (data) => post('/api/app/worksheet/rows/update', data)